<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="イントラネットFW ゾーン接続設定"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row no-gutters justify="end" class="my-2" align="center">
              <v-btn color="primary" @click="toRegister" v-permission.config>
                ゾーン接続追加
              </v-btn>
            </v-row>
            <app-table
              v-model:table-sort-by="zoneSelect.sortBy"
              primary-key="zoneRelationId"
              :fields="zoneSelect.fields"
              :items="zoneSelect.items"
              :per-page="-1"
              :tr-class="() => undefined"
            >
              <template #cell(arrow)>⇒</template>
              <template #cell(zoneDelete)="data">
                <v-btn
                  color="primary"
                  @click="toDelete(data.item)"
                  v-permission.config
                >
                  ゾーン接続削除
                </v-btn>
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >戻る
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { ZoneRelation, ZoneRelationItem } from "@/apis/ZoneRelationApi";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";
import IntranetFwZoneRelationDelete from "@/modals/applianceContractSetting/IntranetFirewall/zoneRelation/ifw/IntranetFwZoneRelationDelete.vue";
import IntranetFwZoneRelationRegister from "@/modals/applianceContractSetting/IntranetFirewall/zoneRelation/ifw/IntranetFwZoneRelationRegister.vue";

export default defineComponent({
  name: "IntranetFwZoneRelationList",
  data() {
    return {
      /** 初期通信完了フラグ */
      isLoaded: false,
      zoneRelation: {} as ZoneRelation,
      zoneSelect: {
        sortBy: {
          key: "srcZoneName",
          order: "asc",
        } as SortItem,
        fields: [
          {
            key: "srcZoneName",
            title: "送信元ゾーン/ゾーン名",
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: false,
            formatter: (value: null, key: null, item: ZoneRelationItem) => {
              return (
                this.$filter.enumTo(item.srcZoneType, "zoneType") +
                `/${item.srcZoneName}`
              );
            },
          },
          { key: "arrow", title: "" },
          {
            key: "dstZoneName",
            title: "宛先ゾーン/ゾーン名",
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: false,
            formatter: (value: null, key: null, item: ZoneRelationItem) => {
              return (
                this.$filter.enumTo(item.dstZoneType, "zoneType") +
                `/${item.dstZoneName}`
              );
            },
          },
          { key: "zoneDelete", title: "", width: "180px" },
        ] as AppTableHeader<ZoneRelationItem>[],
        items: [] as ZoneRelationItem[],
      },
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** データ取得 */
    async load() {
      this.zoneRelation = await this.$api.zoneRelation.getZoneRelation();
      // INTERNETのデータは非表示
      this.zoneSelect.items = this.zoneRelation.zoneRelationList.filter(
        (item) => {
          return (
            item.srcZoneType !== "INTERNET" && item.dstZoneType !== "INTERNET"
          );
        }
      );
    },
    /** ゾーン接続削除 */
    async toDelete(row: ZoneRelationItem) {
      await this.$modal.show(IntranetFwZoneRelationDelete, {
        data: row,
      });
      await this.$api.zoneRelation.deleteZoneRelation(row.zoneRelationId, {
        zoneRelationKeyId: this.zoneRelation.zoneRelationKeyId,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    /** ゾーン接続追加モーダルを表示 */
    async toRegister() {
      await this.$modal.show(IntranetFwZoneRelationRegister, {
        zoneRelationKeyId: this.zoneRelation.zoneRelationKeyId,
        zoneRelation: this.zoneRelation,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
  },
});
</script>
